import * as React from "react";
import Svg, { G, Path, Defs, ClipPath, Rect } from "react-native-svg";
const SVGComponent = (props: any) => (
  <Svg
    width={35}
    height={35}
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_1_3677)">
      <Path
        d="M24.6773 23.5811V21.255C24.6773 20.459 24.9948 19.6958 25.5694 19.107C27.6392 16.9892 28.7788 14.2084 28.7788 11.2764C28.7788 5.05247 23.7534 0.011502 17.4995 1.97072e-05C11.8009 -0.0103944 7.34124 4.10799 6.41358 9.1746C5.74361 12.8286 6.83709 16.4423 9.41258 19.0902C9.99924 19.6929 10.3218 20.4619 10.3218 21.2571V23.5811C10.3218 25.2802 11.6991 26.6572 13.398 26.6572H21.6011C23.2999 26.6572 24.6773 25.2802 24.6773 23.5811ZM22.3261 12.0014L20.5757 13.7517V21.5303C20.5757 22.0972 20.117 22.5557 19.5503 22.5557C18.9837 22.5557 18.5249 22.0972 18.5249 21.5303V14.3526H16.4742V21.5303C16.4742 22.0972 16.0154 22.5557 15.4488 22.5557C14.8821 22.5557 14.4234 22.0972 14.4234 21.5303V13.7517L12.673 12.0014C12.2725 11.6011 12.2725 10.9519 12.673 10.5514C13.0735 10.1511 13.7224 10.1511 14.123 10.5514L15.8733 12.3018H19.1258L20.8761 10.5514C21.2767 10.1511 21.9256 10.1511 22.3261 10.5514C22.7266 10.9519 22.7266 11.6008 22.3261 12.0014Z"
        fill="#F1C75B"
      />
      <Path
        d="M1.02539 12.3018H3.14453C3.71117 12.3018 4.16992 11.8433 4.16992 11.2764C4.16992 10.7097 3.71117 10.251 3.14453 10.251H1.02539C0.458756 10.251 0 10.7097 0 11.2764C0 11.8433 0.458756 12.3018 1.02539 12.3018Z"
        fill="#F1C75B"
      />
      <Path
        d="M33.9746 10.251H31.8555C31.2888 10.251 30.8301 10.7097 30.8301 11.2764C30.8301 11.8433 31.2888 12.3018 31.8555 12.3018H33.9746C34.5412 12.3018 35 11.8433 35 11.2764C35 10.7097 34.5412 10.251 33.9746 10.251Z"
        fill="#F1C75B"
      />
      <Path
        d="M2.40323 19.9921C2.68976 20.4869 3.31888 20.6479 3.80407 20.3678L5.58061 19.3424C6.07114 19.0588 6.23937 18.4321 5.95605 17.9413C5.67167 17.4507 5.04362 17.2825 4.55522 17.5658L2.77868 18.5912C2.28815 18.8745 2.11992 19.5015 2.40323 19.9921Z"
        fill="#F1C75B"
      />
      <Path
        d="M32.5967 2.5604C32.3112 2.06987 31.6834 1.90057 31.1958 2.18496L29.4193 3.21035C28.9288 3.49367 28.7605 4.12065 29.0439 4.61118C29.3304 5.10599 29.9595 5.26701 30.4447 4.98689L32.2212 3.9615C32.7118 3.67792 32.88 3.0512 32.5967 2.5604Z"
        fill="#F1C75B"
      />
      <Path
        d="M2.77868 3.9615L4.55522 4.98689C5.04068 5.26727 5.66953 5.10545 5.95605 4.61118C6.23937 4.12065 6.07114 3.49367 5.58061 3.21035L3.80407 2.18496C3.31434 1.90057 2.68655 2.06987 2.40323 2.5604C2.11992 3.0512 2.28815 3.67792 2.77868 3.9615Z"
        fill="#F1C75B"
      />
      <Path
        d="M29.0439 17.9413C28.7605 18.4321 28.9288 19.0588 29.4193 19.3424L31.1958 20.3678C31.6816 20.6481 32.3104 20.4861 32.5967 19.9921C32.88 19.5015 32.7118 18.8745 32.2212 18.5912L30.4447 17.5658C29.9542 17.2825 29.3272 17.4507 29.0439 17.9413Z"
        fill="#F1C75B"
      />
      <Path
        d="M13.3984 28.7081C13.0473 28.7081 12.7044 28.6721 12.373 28.6045V29.7335C12.373 31.4326 13.7504 32.9464 15.4492 32.9464C15.4492 34.0788 16.3673 34.9972 17.5 34.9972C18.6327 34.9972 19.5508 34.0788 19.5508 32.9464C21.2496 32.9464 22.627 31.4326 22.627 29.7335V28.6045C22.2956 28.6721 21.9527 28.7081 21.6016 28.7081H13.3984Z"
        fill="#F1C75B"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1_3677">
        <Rect width={35} height={35} fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
